import { RequestType } from 'api-validations/stitch'

export const useStitchRequestType = () => {
  return RequestType.Default
}
